import React from 'react'
import SquadPageSuperLikedSamples from 'pages/Squad/containers/SuperLikedSamples'
import logUtil from 'utils/log'
import getIdCustomerUtil from 'utils/customer/get-id'

export default function SquadPageYourSuperLikedSamples () {
  const customerId = getIdCustomerUtil()

  const debugProps = {
    customerId
  }
  logUtil('SquadPageYourSuperLikedSamples').debug('debugProps=', debugProps)
  return (
    <SquadPageSuperLikedSamples
      id={customerId}
      isCurrentCustomer
    />
  )
}
